<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
import {GetLogo} from "@/api/common";

export default {
 data() {
  return {}
 },
 created() {
  this.getInfo()

  !this.$store.getters.getArea.length && this.$store.dispatch('getArea')
 },
 methods: {
  // 获取logo
  getInfo() {
    Promise.try(async () => {
    return await GetLogo()
   }).then((res) => {
    this.$store.commit('setLogo', res.data.image_logo)
   }).catch((err) => {})
  }
 }
}
</script>

<style lang="scss">
</style>
